// import { API_BASE_URL, BEARER_TOKEN, BEARER_TOKEN_V2 } from './apiConfig';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const BEARER_TOKEN_V2 = process.env.REACT_APP_BEARER_TOKEN_V2 || '';

interface ConversationResponse {
	timestamp: string;
	status: string;
	code: number;
	message: {
		conversation_id: string;
	};
	payload: Record<string, any>;
}

const generateConversationId = async (chatbotId: string, input: string, organizationId: string): Promise<ConversationResponse> => {
	const apiUrl = `${API_BASE_URL}/v2/conversation`;
	try {
		const requestOptions: RequestInit = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Bearer: `${BEARER_TOKEN_V2}`,
				'X-Organization': organizationId
			},
			body: JSON.stringify({
				app_id: chatbotId,
				source_id: 'a3e346ef-7b6a-451f-a37b-e567aa414455',
				country_id: 'bc9aa83b-0069-47b5-b0ca-4a52d6a2ae6e',
				answer_question: input,
			}),
		};

		const response = await fetch(apiUrl, requestOptions);
		const data: ConversationResponse = await response.json();

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		return data;
	} catch (error) {
		console.error('Error generating conversation ID:', error);
		throw error;
	}
};

export default generateConversationId;
